import Retailer from '@/utilities/retailerHelper.js'

export default function retailerIyiFinansBlocker(to, _, next) {
  const isIyiFinans = Retailer.isIyiFinans()

  if (isIyiFinans === false) {
    next()
    return
  }

  // Iyi finans retailer - check if route is allowed
  if (Retailer.canAccessRouteMeta(to.meta)) {
    next()
    return
  }

  // Route not allowed for iyi finans retailers
  next({
    name: 'retailer.dashboard'
  })
}
